document.addEventListener('alpine:init', () => {
  Alpine.data('bannerSlider', () => ({
    swiper: null,

    init() {
      this.$nextTick(() => this.initSwiper());
    },

    destroy() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    },

    initSwiper() {
      const container = this.$refs.slider;
      if (!container || typeof Swiper === 'undefined') return;
      if (container.swiper) {
        this.swiper = container.swiper;
        return;
      }

      const slideCount = container.querySelectorAll('.swiper-slide').length;

      this.swiper = new Swiper(container, {
        // Desktop: 4 slides, sides clipped via ±10% bleed CSS
        slidesPerView: 4,
        slidesPerGroup: 1,
        centeredSlides: false,
        spaceBetween: 0,
        loop: true,
        loopedSlides: slideCount,
        loopAdditionalSlides: 2,
        speed: 300,
        watchOverflow: false,
        navigation: {
          prevEl: this.$refs.prev,
          nextEl: this.$refs.next,
        },
        // Swiper 4 breakpoints are max-width
        breakpoints: {
          768: {
            slidesPerView: 1.2,
            centeredSlides: false,
            loopedSlides: slideCount,
          },
        },
      });
    },
  }));
});
